import { useDispatch } from 'react-redux';
import { useMount } from 'react-use';
import { fetchExclusiveOfferList } from 'store/exclusiveOffer/exclusiveOfferActions';

const ExclusiveOffersFetcher = () => {
  const dispatch = useDispatch();

  useMount(() => {
    dispatch(fetchExclusiveOfferList());
  });

  return null;
};

export default ExclusiveOffersFetcher;
